<ng-container *ngIf="dispDialog; else kymw1600contents">
  <table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
    [frontDispFlag]="false">
    <tr class="subwindow-title" cdkDragHandle>
      <th class="window-title-name">画像確認</th>
      <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
    </tr>
    <tr class="subwindow-body">
      <td>
        <ng-container *ngIf="dispDialog; then kymw1600contents"></ng-container>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventBtnClose_CLICKHandler()"></button>
        </div>
        <div cdkDragHandle class="drag-subwindow-bottom-area"></div>
      </td>
    </tr>
  </table>
</ng-container>

<ng-template #kymw1600contents>
  <div class="contents-area" (dragstart)="onDragstartBody($event)">
    <div>
      <h2>検索結果</h2>
      <!-- 検索結果部 -->
      <app-image-info-list id="imageInfoList" #imageInfoList forcedEnabledMode="true" class="space-bottom"
        (eventUseImageList_ITEMCLICK)="eventUseImageList_ITEMCLICKHandler($event)"
        (eventAllSelect_CLICK)="eventAllSelect_CLICKHandler()"
        (eventAllUnSelect_CLICK)="eventAllUnSelect_CLICKHandler()"
        (eventBtnSearch_CLICK)="eventBtnSearch_CLICKHandler()"
        (eventBtnUseSearch_CLICK)="eventBtnUseSearch_CLICKHandler()"
        (eventImageOutput_CLICK)="eventImageOutput_CLICKHandler()"
        (eventOrderCode_CHANGE)="eventOrderCode_CHANGEHandler()"
        [imageInfoList]="kymw1600Model.imageInfoList"></app-image-info-list>
    </div>
      <!-- 画像情報詳細部 -->
    <div>
      <h1>画像詳細情報</h1>
      <app-image-info-detail id="imageInfoDetail" #imageInfoDetail forcedEnabledMode="true"
        [imagePreviewURL]="kymw1600Model.goodsImage" [parentModel]="kymw1600Model"
        (eventImageInfoDetailCHANGE)="eventImageInfoDetailCHANGEHandler()"
        (eventDeleteCLICK)="eventDelete_CLICKHandler()" (eventResetCLICK)="eventReset_CLICKHandler()"
        (eventSettingCLICK)="eventSetting_CLICKHandler()" (eventUseStopCLICK)="eventUseStop_CLICKHandler()"
        (eventUseUnStopCLICK)="eventUseUnStop_CLICKHandler()"></app-image-info-detail>
    </div>
  </div>
</ng-template>